// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only. Unauthorized use,
// copying, or distribution is prohibited and may be prosecuted.

/**
 * One write per selected ROW. At fill grain two ticked rows can be two fills of ONE prescription
 * (ticket #1022): each gets its own WorkBench write, but custom-field values belong to the
 * prescription and are written once — the first row of each prescription carries them.
 * wbIds is aligned index-for-index with rxIds; omitted, the prescription id is the WorkBench target.
 */
export function bulkWritePlan(rxIds: string[], wbIds?: string[]) {
  const seen = new Set<string>()
  return rxIds.map((rxId, i) => {
    const writeCustomFields = !seen.has(rxId)
    seen.add(rxId)
    return { rxId, wbId: wbIds?.[i] ?? rxId, writeCustomFields }
  })
}
